import { render, staticRenderFns } from "./roboMaster.vue?vue&type=template&id=1fc70dea&scoped=true"
import script from "./roboMaster.vue?vue&type=script&lang=js"
export * from "./roboMaster.vue?vue&type=script&lang=js"
import style0 from "./roboMaster.vue?vue&type=style&index=0&id=1fc70dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc70dea",
  null
  
)

export default component.exports